import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Typography } from "@mui/material";
import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { EstadoComponente } from "../components/ui";
import CustomCantidadRecibidaInput from "../components/ui/CustomCantidadRecibidaInput";
import {
  AlertSeverityEnum,
  IDataProducto,
  MaterialTransferido,
} from "../interfaces";
import { cellNotFilter, formatDateWithTimeCell } from "../utils";

import { useProductosEliminados } from "@/store/erp/productos/productosEliminados.store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonSeries from "../components/ui/ButtonSeries/ButtonSeries";
import { ROUTER_PATHS } from "../constants";
import { OrdenesCompra } from "../interfaces/erp/compras/ordenes-compra.interface";

const useTableColumnsRecepcionCompra = () => {
  const navigate = useNavigate();
  //store
  const handleCopiarLista = useCargarSeriesProductos(
    (s) => s.handleCopiarLista,
  );
  const handleActualizarProducto = useCargarSeriesProductos(
    (s) => s.handleActualizarProducto,
  );
  const setOpenModalSeries = useCargarSeriesProductos(
    (s) => s.setOpenModalSeries,
  );
  const setAuxRow = useCargarSeriesProductos((s) => s.setAuxRow);
  const setAlert = useUiStore((s) => s.setAlert);
  const handleCargarProductos = useProductosEliminados(
    (s) => s.handleCargarProductos,
  );

  //* State
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [solicitudIngreso, setSolicitudIngreso] = useState<string>("");
  const [codigoOrdenCompra, setCodigoOrdenCompra] = useState<string>("");
  const [idEdit, setIdEdit] = useState<string>("");
  const [observacionSolicitante, setObservcacionSolicitante] =
    useState<string>("");
  const [observacionSolicitudRevision, setObservacionSolicitudRevision] =
    useState<string>("");
  const [observacionGeneraOrden, setObservacionGeneraOrden] =
    useState<string>("");
  const [observacionRevisorOrden, setObservacionRevisorOrden] =
    useState<string>("");
  const [proveedor, setProveedor] = useState("");

  //**capturar el registro */
  const onDetails = (e: MRT_RowData) => {
    calcularCantidadPendientes(e.detalles);
    setProveedor(e?.proveedor);
    setObservacionGeneraOrden(e?.observaciones?.observacionCreador);
    setObservacionRevisorOrden(e?.observaciones?.observacionRevisor);
    setObservcacionSolicitante(
      e?.solicitud_ingreso_data?.observaciones?.observacionSolicitante,
    );
    setObservacionSolicitudRevision(
      e?.solicitud_ingreso_data?.observaciones?.observacionRevision,
    );
    setSolicitudIngreso(e?.solicitud_ingreso);
    setCodigoOrdenCompra(e?.codigo);
    setIdEdit(e?.id_orden_compra);

    return navigate(
      ROUTER_PATHS.inventario.recepcionCompraCrear.replace(
        ":id",
        e.id_orden_compra!,
      ),
      {
        state: {
          proveedor: e.proveedor,
          observacionGeneraOrden: e.observaciones?.observacionCreador,
          observacionRevisorOrden: e.observaciones?.observacionRevisor,
          observacionSolicitante:
            e.solicitud_ingreso_data?.observaciones?.observacionSolicitante,
          observacionSolicitudRevision:
            e?.solicitud_ingreso_data?.observaciones?.observacionRevision,
          solicitudIngreso: e.solicitud_ingreso,
          codigoOrdenCompra: e.codigo,
          id_orden_compra: e?.id_orden_compra,
          estado_orden: e?.estado_orden,
        },
      },
    );
  };

  const calcularCantidadPendientes = (productos: IDataProducto[]) => {
    const resultado = productos.map((item: IDataProducto) => {
      const cantidadAcumulada =
        Number(item.cantidad_acumulada || 0) + Number(item.cantidad_recibida!);
      const cantidadPendiente = Number(item.cantidad) - cantidadAcumulada; ///aqui
      const cantidadRecibidaNormalizada =
        Number(item.cantidad_recibida) > 0
          ? 0
          : Number(item.cantidad_recibida) || 0;
      return {
        ...item,
        cantidad: Number(item.cantidad),
        stock_actual: String(item.stock_actual),
        cantidad_aprobada: Number(item.cantidad_aprobada),
        cantidad_acumulada: cantidadAcumulada,
        cantidad_pendiente: cantidadPendiente,
        cantidad_recibida: cantidadRecibidaNormalizada,
      };
    });
    const itemInconsitente = resultado.find(
      (item) => item.cantidad !== item.cantidad_aprobada,
    );
    if (itemInconsitente) {
      toast.error(
        "Error: esta orden no puede visualizarse porque, tras el reverso realizado, algunos datos quedaron inconsistentes.",
      );
      console.log(
        ` Inconsistencia detectada:\n` +
          `La Cantidad: ${itemInconsitente.cantidad}\n` +
          `Debe ser igual a Cantidad Aprobada: ${itemInconsitente.cantidad_aprobada}\n`,
      );
      return;
    }
    const productosConPendiente = resultado.filter(
      (item) => item.cantidad_pendiente > 0,
    );
    const productosSinPendientes = resultado.filter(
      (item) => item.cantidad_pendiente === 0,
    );
    handleCopiarLista(productosConPendiente);
    handleCargarProductos(productosSinPendientes);
  };

  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: "descripcion",
        header: "Descripcion",
        Cell: ({ row }) => row.original?.producto_data?.descripcion || "N/A",
      },
      {
        accessorKey: "cantidad_aprobada",
        header: "Cant. Aprobada",
      },
      {
        accessorKey: "cantidad",
        header: "cant. Esperada",
      },
    ],
    [],
  );
  const columnsRecepcionCompra = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: "cantidad_recibida",
        header: "cant. A recibir",
        Cell: ({ row }) => {
          const cantidadRecibida = Number(row.original.cantidad_recibida) || 0;
          const cantidadMax =
            Number(row.original.cantidad) -
            Number(row.original.cantidad_acumulada);

          return (
            <CustomCantidadRecibidaInput<MaterialTransferido>
              value={cantidadRecibida.toString()}
              maxValue={cantidadMax}
              handleValue={(value) => {
                if (value > cantidadMax) return;
                handleActualizarProducto(row.original.id, {
                  ...row.original,
                  cantidad_recibida: value,
                });
              }}
              row={row}
            />
          );
        },
      },
      {
        accessorKey: "cantida_pendiente",
        header: "Cant. Pendiente",
        Cell: ({ row }) => {
          const cantidadTotal = row.original.cantidad_acumulada!;
          const cantidadRecibida = Number(row.original.cantidad_recibida);
          const cantidad = Number(row.original.cantidad);
          const cantidadPendiente =
            cantidad - (Number(cantidadTotal) + cantidadRecibida);
          return (
            <Typography
              color={cantidadPendiente > 0 ? "warning.main" : "green"}
            >
              {cantidadPendiente}
            </Typography>
          );
        },
      },
      {
        accessorKey: "series",
        header: "Series",
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const original = row.original;

          const { contiene_serie } = original;

          return (
            <ButtonSeries
              disabled={!contiene_serie}
              onClick={() => {
                if (!row.original.contiene_serie)
                  return setAlert(
                    true,
                    "Seleccionar la opción de habilitar serie.",
                    AlertSeverityEnum.info,
                  );
                if (row.original.cantidad_recibida === 0)
                  return setAlert(
                    true,
                    "La opción de series se habilita solo después de ingresar la cantidad a recibir.",
                    AlertSeverityEnum.info,
                  );
                setOpenModalSeries(true);
                setAuxRow(row.original);
              }}
            />
          );
        },
      },
      ...columnsInfoProducto,
    ],
    [],
  );
  const columnsGeneralRecepcion = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(
    () => [
      {
        accessorKey: "detalles",
        header: "Producto",
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnActions: false,
        size: 100,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={() => {
                onDetails(row.original);
              }}
            >
              {"Ver"}
            </Button>
          );
        },
      },

      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
      },
      {
        accessorKey: "solicitud_ingreso",
        header: "solicitud ingreso",

        Cell: ({ row }) => row.original.solicitud_ingreso || "N/A",
      },
      {
        accessorKey: "plazo_pago",
        header: "plazo pago",
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_orden",
        header: "fecha orden",
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_orden"),
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_compra",
        header: "fecha Compra",
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_compra"),
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_entrega",
        header: "fecha entrega",
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_entrega"),
      },
      {
        accessorKey: "forma_pago_data.nombre",
        header: "forma_pago",
        Cell: ({ row }) => row.original.forma_pago_data?.nombre || "N/A",
      },
      {
        accessorKey: "proveedor",
        header: "proveedor",
        Cell: ({ row }) => row.original.proveedor_data?.razon_social || "N/A",
      },
      {
        ...cellNotFilter,
        enableColumnActions: false,
        accessorKey: "estado_solicitud",
        header: "estado",
        Cell: ({ row }) =>
          row.original.estado_orden != null ? (
            <EstadoComponente
              backgroundColor={
                row.original.estado_orden === "ABIERTO" ? "blue" : "orange"
              }
              texto={row.original.estado_orden || ""}
            />
          ) : null,
      },
    ],
    [],
  );
  const columnsRecepcionSinPendiente = useMemo<
    MRT_ColumnDef<MaterialTransferido>[]
  >(
    () => [
      {
        accessorKey: "cantidad_recibida",
        header: "cant. A recibir",
        Cell: ({ row }) => {
          const cantidadRecibida = Number(row.original.cantidad_recibida) || 0;
          const cantidadMax =
            Number(row.original.cantidad) -
            Number(row.original.cantidad_acumulada);
          useEffect(() => {
            if (cantidadRecibida > 0) {
              handleActualizarProducto(row.original.id, {
                ...row.original,
                cantidad_recibida: 0,
              });
            }
          }, []);

          return (
            <CustomCantidadRecibidaInput<MaterialTransferido>
              value={cantidadRecibida > 0 ? "0" : cantidadRecibida.toString()}
              maxValue={cantidadMax}
              handleValue={(value) => {
                if (value > cantidadMax) return;
                handleActualizarProducto(row.original.id, {
                  ...row.original,
                  cantidad_recibida: value,
                });
              }}
              row={row}
            />
          );
        },
      },
      {
        accessorKey: "cantidad_pendiente",
        header: "Cant. Pendiente",
        Cell: ({ row }) => {
          return (
            <Typography color={"green"} fontWeight={"bold"}>
              {row.original.cantidad_pendiente}
            </Typography>
          );
        },
      },
      {
        accessorKey: "series",
        header: "Series",
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const original = row.original;

          const { contiene_serie } = original;

          return (
            <ButtonSeries
              disabled={!contiene_serie}
              onClick={() => {
                if (!row.original.contiene_serie)
                  return setAlert(
                    true,
                    "Seleccionar la opcion de habilitar serie.",
                    AlertSeverityEnum.info,
                  );
                setOpenModalSeries(true);
                setAuxRow(row.original);
              }}
            />
          );
        },
      },
      ...columnsInfoProducto,
    ],
    [],
  );
  return {
    columnsRecepcionCompra,
    columnsGeneralRecepcion,
    isOpenModal,
    setIsOpenModal,
    solicitudIngreso,
    codigoOrdenCompra,
    idEdit,
    observacionSolicitante,
    observacionSolicitudRevision,
    columnsRecepcionSinPendiente,
    observacionGeneraOrden,
    observacionRevisorOrden,
    proveedor,
  };
};
export default useTableColumnsRecepcionCompra;
